/* eslint-disable jira/filename-case */
import { COLUMN_ID_MERGED_COLUMN } from '@jira/issue-table__issue-table-common/src/constants.tsx';

export const PACKAGE_NAME = 'jiraNativeIssueTable';
export const TEAM_NAME = 'empanada';

export const SORT_ASC = 'ASC';
export const SORT_DESC = 'DESC';
export const SORT_NONE = 'NONE';

// Modification to the list of visible columns, either by adding or removing columns
export const MODIFY_COLUMNS = 'MODIFY_COLUMNS';
// Reordering of columns via a drag & drop operation
export const REORDER_COLUMNS = 'REORDER_COLUMNS';
// Restore default columns via column picker
export const RESTORE_COLUMNS = 'RESTORE_COLUMNS';

// Target positions when moving columns
export const MOVE_COLUMN_FIRST = 'MOVE_COLUMN_FIRST';
export const MOVE_COLUMN_LEFT = 'MOVE_COLUMN_LEFT';
export const MOVE_COLUMN_RIGHT = 'MOVE_COLUMN_RIGHT';
export const MOVE_COLUMN_LAST = 'MOVE_COLUMN_LAST';

export const BORDER_WIDTH = '1px';

export const HEADER_HEIGHT = 40;
export const ROW_HEIGHT = 40;

export const COLUMN_ID_MEATBALL_MENU = '__issuetable_internal_meatball';
export const COLUMN_ID_EXPAND_BUTTON = '__issuetable_internal_expand_button';
export const COLUMN_ID_CHECKBOX = '__issuetable_internal_checkbox';
export const COLUMN_ID_INTERNAL_COLUMN = '__issuetable_internal';
export const COLUMN_ID_TIMELINE = 'timeline';

export const ACTION_COLUMNS: string[] = [
	COLUMN_ID_EXPAND_BUTTON,
	COLUMN_ID_MEATBALL_MENU,
	COLUMN_ID_CHECKBOX,
	COLUMN_ID_MERGED_COLUMN,
];

export const NON_MOVABLE_COLUMN_IDS: string[] = [
	COLUMN_ID_TIMELINE,
	COLUMN_ID_CHECKBOX,
	COLUMN_ID_MERGED_COLUMN,
	COLUMN_ID_MEATBALL_MENU,
];

export const EXPAND_BUTTON_WIDTH = 24;
export const CREATE_CHILD_BUTTON_WIDTH = 24;
export const EXPAND_CELL_PADDING: number = 8 * 2;
export const DEPTH_WIDTH = 24;

// LDR: https://hello.atlassian.net/wiki/spaces/JFE/pages/2625316871/LDR+Maximum+number+of+columns+to+allow+in+NIN+in+M7.3
export const MAX_COLUMNS = 500;
export const CHILD_QUERY_PAGE_SIZE = 50;

export const COLUMN_TYPE_EPIC_LINK = 'com.pyxis.greenhopper.jira:gh-epic-link';
export const COLUMN_TYPE_PARENT_LINK = 'com.atlassian.jpo:jpo-custom-field-parent';

// Column Widths
export const MINIMUM_COLUMN_WIDTH_COMPACT = 40; // 2 x 8px cell padding + 24px icon size
export const MINIMUM_COLUMN_WIDTH = 69; // 2 x 8px cell padding + 2 x 24px icon size + 4px gap + 1px border
export const DEFAULT_COLUMN_WIDTH = 170;
export const MAXIMUM_COLUMN_WIDTH = 999;

export const SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH = 80;

// Column Widths for specific column types
export const MINIMUM_MERGED_CELL_COLUMN_WIDTH = 180;

// 200 EditView Input + 4 focused sides border
export const COLUMN_WIDTH_ASSIGNEE = 204;

export const COLUMN_WIDTH_TEXT_LONG = 400;
export const COLUMN_WIDTH_TEXT_SHORT = 300;
export const COLUMN_WIDTH_TEXT_SUMMARY = 450;

// Column operations
export const COLUMN_OPERATION_REORDER = 'reorder';
export const COLUMN_OPERATION_RESIZE = 'resize';
export const INSERT_COLUMN_BUTTON_Y_OFFSET = -16;

// Column resize handle
export const COLUMN_RESIZE_HANDLE_FULL_HEIGHT = 'FULL_HEIGHT';
export const COLUMN_RESIZE_HANDLE_HEADER_ONLY = 'HEADER_ONLY';

// Row operations
export const ROW_OPERATION_REORDER = 'rowReorder' as const;

export const DENSITY_COMPACT = 'COMPACT';
export const DENSITY_FULL = 'FULL';

export const LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
export const LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE =
	'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';

export const CHILD_ITEMS_EXPERIENCE = 'loadChildItems';

export const CHILD_ITEMS_LOAD_MORE_EXPERIENCE = 'loadMoreChildItems';

export const GROUPED_ITEMS_EXPERIENCE = 'loadGroupChildren';

export const GROUPED_LOAD_MORE_EXPERIENCE = 'loadMoreGroupedItems';

export const INLINE_ISSUE_CREATE_EXPERIENCE = 'createIssue';

export const ANALYTICS_SOURCE = 'jira-native-issue-table' as const;

export const MAKE_CHILD = 'make-child';
export const REORDER_ABOVE = 'reorder-above';
export const REORDER_BELOW = 'reorder-below';
export const INSTRUCTION_BLOCKED = 'instruction-blocked';

export const SUBTASK_HIERARCHY_LEVEL = -1;

export const COLUMN_PICKER_CONFIGURATION_CONTAINER = 'COLUMN_PICKER_CONFIGURATION_CONTAINER';
export const COLUMN_PICKER_ADD_COLUMN_CONTAINER = 'COLUMN_PICKER_ADD_COLUMN_CONTAINER';

// How long the issue row highlight should remain visible after the issue was successfully created or reparented
export const HIGHLIGHT_LINGER_DURATION_MS = 2000;

// Sorting
export const SORT_A_TO_Z = 'a_to_z';
export const SORT_Z_TO_A = 'z_to_a';
export const SORT_LOWEST_TO_HIGHEST = 'lowest_to_highest';
export const SORT_HIGHEST_TO_LOWEST = 'highest_to_lowest';
export const SORT_OLDEST_TO_NEWEST = 'oldest_to_newest';
export const SORT_NEWEST_TO_OLDEST = 'newest_to_oldest';

// Z-index
export const Z_INDEX_STICKY_COLUMN = 7;
// Z_INDEX_TABLE_OVERLAY needs to be greater than the value of Z_INDEX_STICKY_COLUMN
export const Z_INDEX_TABLE_OVERLAY = 8;

export const Z_INDEX_COLUMN_HEADER_MORE_ACTIONS = 10;

export const SMALL_SCREEN_WIDTH = 1024;

export const FIXED_POSITION_COLUMN_TYPES: string[] = [COLUMN_ID_TIMELINE, COLUMN_ID_MEATBALL_MENU];
